import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import GuestGuard from './components/GuestGuard';
import LoadingScreen from './components/LoadingScreen';
import Layout from './views/layout/Layout';
import useAuth from 'src/hooks/useAuth';

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// Authentication views
const Login = Loadable(lazy(() => import('./views/auth/Login')));

// APP views
const Home = Loadable(lazy(() => import('./views/priceMonitor/index')));
const HistoricalData = Loadable(lazy(() => import('./views/historicalData')));
const Report = Loadable(lazy(() => import('./views/report')));

// Error views
const AuthorizationRequired = Loadable(lazy(() => import('./views/errors/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('./views/errors/NotFound')));
const ServerError = Loadable(lazy(() => import('./views/errors/ServerError')));

const HomeRoute = () => {
  const { permissions } = useAuth().user;

  if (!permissions.show_prices_search) {
    return <Navigate to="/reports" replace />;
  }

  return <Home />;
};

const routes = [
  {
    path: '/login',
    element: <Navigate to="/auth/login" replace />
  },
  {
    path: '/auth',
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        )
      }
    ]
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <HomeRoute />
      },
      {
        path: '/historical_data',
        element: <HistoricalData />
      },
      {
        path: '/reports',
        element: <Report />
      }
    ]
  },
  {
    path: '*',
    element: '',
    children: [
      {
        path: '401',
        element: <AuthorizationRequired />
      },
      {
        path: '404',
        element: <NotFound />
      },
      {
        path: '500',
        element: <ServerError />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default routes;
